/**
 * Features for product type smart.
 */
export enum LicenseSmartFeature {
  SMART_MOBILE = 'smart_mobile',
  SMART_WEB = 'smart_web',
  SMART_KIT = 'smart_kit',
  SMART_SUPPORT = 'smart_support'
}
